import * as React from 'react';

import Profile from 'assets/icons/nav/icon-profile.svg';

import { Button } from 'basics/buttons';

import { Empty, IconWrap } from './DelegatesList.styled';

const DelegateDetailsPrompt = ({ onDelegate }: { onDelegate?: () => void }) => (
    <Empty onClick={event => event.stopPropagation()}>
        <IconWrap>
            <Profile />
        </IconWrap>
        <span>Select a delegate to see the details</span>
        <Button isBig fullWidth isRounded disabled={!onDelegate} onClick={onDelegate}>
            Delegate ICE
        </Button>
    </Empty>
);

export default DelegateDetailsPrompt;
